export function getParameterByName(name: string, url?: string, ifMissing: string | null = ''): string | null {
  if (!url) { url = window.location.href; }
  name = name.replace(/[\[\]]/g, '\\$&');
  const regex = new RegExp(`[?&]${name}(=([^&#]*)|&|#|$)`);
  const results = regex.exec(url);
  if (!results) { return ifMissing; }
  if (!results[2]) { return ifMissing; }
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}
